import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollaborations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "collaborations",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 32 32",
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M11,6.4c-0.7,0-1.3,0.6-1.3,1.3C9.7,8.4,10.3,9,11,9c0.7,0,1.3-0.6,1.3-1.3C12.3,7,11.7,6.4,11,6.4z M11,11.7 c-1.2,0-2.2,0.7-2.7,1.8l-0.1,0.1h5.5l-0.1-0.1c-0.4-1-1.4-1.7-2.5-1.8L11,11.7z M11,4.4c1.8,0,3.3,1.5,3.3,3.3c0,1-0.4,1.8-1.1,2.4 c1.6,0.8,2.7,2.5,2.7,4.4c0,0.6-0.4,1-1,1H7.1c-0.6,0-1-0.4-1-1c0-1.9,1.1-3.6,2.7-4.4C8.1,9.6,7.7,8.7,7.7,7.7 C7.7,5.9,9.2,4.4,11,4.4z M21,13.4c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3C22.3,14,21.7,13.4,21,13.4z  M21,18.7c-1.2,0-2.2,0.7-2.7,1.8l-0.1,0.1h5.5l-0.1-0.1c-0.4-1-1.4-1.7-2.5-1.8L21,18.7z M11,18.4c-0.7,0-1.3,0.6-1.3,1.3 c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3C12.3,19,11.7,18.4,11,18.4z M21,11.4c1.8,0,3.3,1.5,3.3,3.3c0,1-0.4,1.8-1.1,2.4 c1.6,0.8,2.7,2.5,2.7,4.4c0,0.6-0.4,1-1,1h-7.8c-0.6,0-1-0.4-1-1c0-1.9,1.1-3.6,2.7-4.4c-0.7-0.6-1.1-1.5-1.1-2.4 C17.7,12.9,19.2,11.4,21,11.4z M11,23.7c-1.2,0-2.2,0.7-2.7,1.8l-0.1,0.1h5.5l-0.1-0.1c-0.4-1-1.4-1.7-2.5-1.8L11,23.7z M11,16.4 c1.8,0,3.3,1.5,3.3,3.3c0,1-0.4,1.8-1.1,2.4c1.6,0.8,2.7,2.5,2.7,4.4c0,0.6-0.4,1-1,1H7.1c-0.6,0-1-0.4-1-1c0-1.9,1.1-3.6,2.7-4.4 c-0.7-0.6-1.1-1.5-1.1-2.4C7.7,17.9,9.2,16.4,11,16.4z" })]
});
const ForwardRef = forwardRef(SvgCollaborations);
export default ForwardRef;
